import { useEffect, useState } from 'react';

import { joinRoom, leaveRoom, socket } from '@mint-sdk/api-media-plan/socket';
import { getRouteApi } from '@mint/routing';

import { useChosenLevel } from '../useChosenLevel.js';
import { useRefreshOnReconnect } from './useRefreshOnReconnect.js';
import { useSocketEvents } from './useSocketEvents.js';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const usePlanningSocketLegacy = () => {
  const { level, id } = useChosenLevel();
  const { mediaPlan: planMediaDataId } = routerApi.useSearch();

  // Registering events
  useSocketEvents();

  // refetch all data in background in case internet lost or socket disconnected
  useRefreshOnReconnect();

  const [isConnected, setIsConnected] = useState(
    () => socket.getClient().connected ?? false,
  );

  //  Join the "general" room for this media plan
  useEffect(() => {
    if (!planMediaDataId || !isConnected) {
      return;
    }

    joinRoom({ room: 'general', entityId: planMediaDataId });
  }, [planMediaDataId, isConnected]);

  //  Join/leave the level-specific context room
  useEffect(() => {
    if (!id || !level || !isConnected) {
      return;
    }

    joinRoom({ room: level, entityId: id });

    return () => {
      leaveRoom({ room: level, entityId: id });
    };
  }, [level, id, isConnected]);

  // Register connect/disconnect listeners
  useEffect(() => {
    const client = socket.getClient();

    client.on('connect', () => {
      setIsConnected(true);
    });

    client.on('disconnect', () => {
      setIsConnected(false);
    });

    return () => {
      client.off('connect');
      client.off('disconnect');
    };
  }, []);
};
